import { render, staticRenderFns } from "./FormatPageLocator.vue?vue&type=template&id=1ea33ca7&scoped=true&"
import script from "./FormatPageLocator.vue?vue&type=script&lang=ts&"
export * from "./FormatPageLocator.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageLocator.vue?vue&type=style&index=0&id=1ea33ca7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea33ca7",
  null
  
)

export default component.exports